const type = 'SET_LIMITS_LOADING';

const setLimitsLoading = () => ({
  type,
});

export { type };
export default setLimitsLoading;
